import { create } from 'zustand';
import { Group } from '../../types/Group';
import { getAllGroups } from '../../api/groups/AllGroups';
import { useAuthStore } from '../auth/auth';

interface GroupsStore {
    groups: Group[];
    isLoading: boolean;
    fetchGroups: () => Promise<void>;
}

export const useGroupsStore = create<GroupsStore>((set, get) => ({
    groups: [],
    isLoading: false,
    fetchGroups: async () => {
        const { SmartDVRToken, user } = useAuthStore.getState();
        if (!user || !SmartDVRToken) {
            console.error('User or token information is missing.');
            return;
        }

        const state = get();
        if (state.isLoading) return;

        set({ isLoading: true });
        try {
            const response = await getAllGroups(SmartDVRToken, user.login);
            const groups = response?.data || [];
            set({ groups });
        } catch (error) {
            console.error('Error fetching groups:', error);
        } finally {
            set({ isLoading: false });
        }
    },
}));
